import api from './api';
import { leadsService } from './leads';

export const ipdDoneService = {
  // Request/Update Lead Status to IPD Done
  requestIPDDone: async (leadId) => {
    return await leadsService.updateLeadStatus(leadId, 'ipd_done');
  },

  // Approve IPD Done Request
  approveIPDRequest: async (leadId) => {
    const response = await api.post(`/leads/${leadId}/approve-ipd/`, {});
    return response.data;
  },

  // Reject IPD Done Request
  rejectIPDRequest: async (leadId, newStatus = 'followup') => {
    const response = await api.post(`/leads/${leadId}/reject-ipd/`, {
      new_status: newStatus
    });
    return response.data;
  },

  // Get Pending IPD Approvals
  getPendingIPDApprovals: async () => {
    const response = await api.get('/leads/pending-ipd-approvals/');
    return response.data;
  },

  // Get IPD Statistics with Filters
  getIPDStatistics: async (filters = {}) => {
    const params = new URLSearchParams();

    // Add filters to params
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });

    const response = await api.get(`/reports/ipd-statistics/?${params}`);
    return response.data;
  },
};

// Status constants for IPD Done
export const IPD_STATUS = {
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// Filter options
export const IPD_FILTER_OPTIONS = {
  periods: [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'custom', label: 'Custom' }
  ],
  statusFilters: [
    { value: 'all', label: 'All Team Members' },
    { value: 'ipd_done_only', label: 'Only with IPD Done' },
    { value: 'pending_only', label: 'Only with Pending Requests' },
    { value: 'has_ipd', label: 'Has IPD Done' },
    { value: 'has_pending', label: 'Has Pending Requests' }
  ],
  roleFilters: [
    { value: 'all', label: 'All Roles' },
    { value: 'bda', label: 'BDA Only' },
    { value: 'team_lead', label: 'Team Lead Only' }
  ],
  sortOptions: [
    { value: 'ipd_count', label: 'IPD Done Count' },
    { value: 'conversion_rate', label: 'Conversion Rate' },
    { value: 'pending_count', label: 'Pending Requests' },
    { value: 'name', label: 'Name' }
  ]
};